import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const options = {
  order: [
    'path',
    'cookie',
    'navigator',
    'localStorage',
    'subdomain',
    'queryString',
    'htmlTag',
  ],
  lookupFromPathIndex: 0,
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    detection: options,
    supportedLngs: ['en', 'jp'],
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          tag: {
            open_source: 'Open Source',
          },
          intro: {
            title: 'Welcome to My Domain.',
            name: "I'm Justin.",
            education1: 'I graduated from ',
            education2: 'UC San Diego',
            education3:
              ' with a degree in Bioinformatics and a minor in Computer Science. ',
            hobbies:
              'My hobbies include gaming, reading, studying foreign languages and bouldering.',
          },
          projects: {
            title: 'Projects.',
            meraki_analytics_lolstaticdata: {
              description: 'League of Legends Static Data',
              bullet_1:
                'Open-Source project aiming to generate accurate champion and item data for League of Legends. ',
              bullet_2:
                'Modified scripts to parse scraped fields correctly and handle exceptions. ',
            },
            lol_session: {
              description: 'League of Legends LP Tracker',
              bullet_1:
                'Researched, tested, and implemented data integration from the League of Legends Live Client Data Api. ',
              bullet_2:
                'Created simple interface for users to configure preferences. ',
              bullet_3: 'Implemented persistent settings for easy re-use. ',
            },
            demacia: {
              description: 'Discord Tournament Bot',
              bullet_1:
                'Researched and adapted Battlefy API / Puppeter to fully automate bot commands on Heroku instance. ',
            },
            data_loader: {
              description: 'Post-Game Match Editor',
              bullet_1:
                'Referenced and implemented Riot Developer API and DataDragon to translate and improve data. ',
              bullet_2:
                'Implemented support for various data formats (JSON, CSV) for flexibility. ',
            },
            kanban_ts: {
              description: 'Productivity Board',
              bullet_1:
                'Implemented redux store to manage and edit tasks from different interfaces.',
              bullet_2:
                'Built out interfaces and managed types to ensure function call consistency. ',
            },
            taglyne: {
              description: 'Event Manager',
              bullet_1: 'Set up and configured Google Cloud/Firebase hosting.',
              bullet_2: 'Designed and developed web pages and user interfaces.',
            },
            autojam: {
              description: 'Drop Wifi Devices',
              bullet_1:
                'Utilizes aircrack-ng suite and data pipelines to completely automate deauthentication. ',
            },
          },
          work: {
            title: 'Work.',
            tokuty: {
              duration: 'Spring 2026 - Present',
              location: 'Tokyo, Japan',
              company: "tokuty",
              title: 'Full-Stack Engineer',
              bullet_1:
                'Built LINE integration to automate mission-critical workflows.',
              bullet_2:
                'Implemented essential Front-End (React + Typescript) and Back-End (Ruby-on-Rails) updates.',
              bullet_3:
                'Maintained automated email system serving 30,000 users per month.',
            },
            u_gg: {
              duration: 'Spring 2021 - Spring 2025',
              location: 'Austin, Texas, United States',
              company: "U.GG",
              title: 'Full-Stack Engineer',
              bullet_1:
                'Key contributor to release + maintenance of U.GG Desktop App.',
              bullet_1_5: 'KPI: 1.5M+ downloads, $4.2M+ revenue, 180K+ DAU',
              bullet_2:
                'Shipped critical updates and redesigns to the U.GG Website serving 3M DAU. ',
              bullet_3:
                'Developed and built data-driven UI (Figma), reusable components, and animations.',
              bullet_4:
                'Implemented platform technology, APIs, internal tooling, and modern ad tech with partners (Overwolf, Playwire).',
              bullet_5:
                'Identified and resolved performance and scalability issues.',
            },
            oracle: {
              duration: 'Summer 2019 - Spring 2021',
              location: 'Santa Monica, CA, United States',
              company: "Oracle",
              title: 'Cloud Engineer',
              bullet_1:
                'Worked closely with cross-functional teams (Sales/Project MGMT) to translate feature requests into feasible design. ',
              bullet_2:
                'Gained hands-on experience with API Protocols and Data Formats (REST, JSON, SOAP and XML). ',
              bullet_3:
                'Created python script to automate shell and SQL commands over SSH. ',
              bullet_4:
                'Designed, built, and reviewed customer integrations + data transformations. ',
            },
            gtri: {
              duration: 'Spring 2018 - Spring 2019',
              location: 'San Diego, CA, United States',
              company: "GTRI",
              title: 'Information Technology Intern',
              bullet_1:
                'Utilized JIRA to promote configuration management and development processes. ',
              bullet_2:
                'Supplemented internal wiki (Confluence) with technical documentation, manuals and IT policies. ',
            },
            biosero: {
              duration: 'Summer 2017 - Spring 2018',
              location: 'San Diego, CA, United States',
              company: "Biosero",
              title: 'Software Engineering Intern',
              bullet_1:
                'Developed driver software to adapt to new hardware and improve performance. ',
              bullet_2:
                'Determined appropriate manual or automated test strategy based on feature scope. ',
              bullet_3:
                'Maintained, documented, and reported software issues/concern. ',
            },
          },
          education: {
            title: 'Education.',
            university: {
              name_1: 'University of California, ',
              name_2: 'San Diego',
              degree: 'B.S. Bioinformatics, Minor: Computer Science',
              location: 'La Jolla, CA, United States',
              duration: 'Fall 2015 - Summer 2019'
            },
            study_abroad: {
              name: 'Intercultural Institute of Japan',
              degree: 'Foreign Language Study・Attendance: 99.6%',
              location: 'Tokyo, Japan',
              duration: 'Spring 2025 - Spring 2026'
            },
            languages: {
              title: 'Languages',
              english: {
                label: "English: Native Proficiency"
              },
              japanese: {
                label: "Japanese: Professional Working Proficiency",
                exam_1: {
                  name: "JLPT N3 (Winter 2026)",
                  section_1: "Language Knowledge (Vocabulary/Grammar): 43/60",
                  section_2: "Reading: 56/60",
                  section_3: "Listening: 60/60",
                  section_total: "Total: 159/180 PASS (CEFR: B1)",
                }
              },
              chinese: {
                label: "Chinese: Conversational Proficiency",
                exam_1: {
                  name: "Hanyu Shuiping Kaoshi 3.0 (Spring 2026)",
                  section_1: "Listening: 100/100",
                  section_2: "Reading: 100/100",
                  section_3: "Writing: 88/100",
                  section_total: "Total: 288/300 PASS",
                }
              },
            }
          },
          footer: {
            thanks: 'You made it to the end!',
            heart_1: 'Built with ',
            heart_2: '',
            and: 'and',
          },
        },
      },
      jp: {
        translation: {
          tag: {
            open_source: 'オープンソース',
          },
          intro: {
            title: 'ドメインへようこそ。',
            name: 'ジャスティンと申します。',
            education1: '',
            education2: 'サンディエゴ大学',
            education3:
              'を卒業しました。バイオインフォマティクスを専攻し、コンピューターサイエンスを副専攻しました。 ',
            hobbies: '趣味はゲームや読解、外語とボルダリングです。',
          },
          projects: {
            title: 'プロジェクト。',
            meraki_analytics_lolstaticdata: {
              description: 'リーグ・オブ・レジェンド 静的データ',
              bullet_1:
                'リーグ・オブ・レジェンドの正確なチャンピオンとアイテムデータを生成することを目的としたオープンソースプロジェクト。',
              bullet_2:
                'スクリプトを修正し、スクレイピングしたデータを正しく直し、例外を処理できるようにした。',
            },
            lol_session: {
              description: 'リーグ・オブ・レジェンド LPトラッカー',
              bullet_1:
                'リーグ・オブ・レジェンド ライブクライアントデータAPI使えるデータを調査した、必要データのパイプライン実装しました',
              bullet_2:
                'ユーザーが設定を構成するためのインターフェースを作成しました。',
              bullet_3:
                '簡単に使えるために、設定を保存システムを実装しました。',
            },
            demacia: {
              description: 'ディスコードトーナメントボット',
              bullet_1:
                'Battlefy APIとPuppeterのサービスをHeroku・Dynoに正しく実行ために、調査やテストや実装しました。',
            },
            data_loader: {
              description: '試合後データエディター',
              bullet_1:
                'Riot Developer APIとDataDragonからデータ構造を修正し、また欠損データを記入できるアプリ実装しました。',
              bullet_2: 'JSONやCSV形式サポートを実装しました。',
            },
            kanban_ts: {
              description: '生産性ボード',
              bullet_1:
                'Redux実行して、様々なインタフェースと同じデータを使うことと変化になりました。',
              bullet_2: 'インタフェースを作成し、データ種類を実施した。',
            },
            taglyne: {
              description: 'イベントマネージャー',
              bullet_1: 'Google CloudとFirebase hostingの設定済みました。',
              bullet_2: 'ウェブページとユーザーインターフェース作成しました。',
            },
            autojam: {
              description: 'Wi-Fiデバイスを落とす',
              bullet_1:
                '自動に実行ために、aircrack-ng suiteとデータパイプラインを実装しました。',
            },
          },
          work: {
            title: '職歴。',
            tokuty: {
              duration: '2026年春 - 現在',
              location: '日本東京都港区',
              company: 'トクティー株式会社',
              title: 'フルスタックエンジニア',
              bullet_1:
                'ゼロからLINE接続を作って、重要な情報を自動に送る機能を担当されました。',
              bullet_2:
                'サイト上でフロントエンド（REACT）とバックエンド（Ruby on Rails）デザインやビジネスロジックを実装しました。',
              bullet_3:
                '毎月３万メール送るシステムを修正・改善しました。',
            },
            u_gg: {
              duration: '2021年春 - 2025年春',
              location: '米国、テキサス州、オースティン、',
              company: 'U.GG株式会社',
              title: 'フルスタックエンジニア',
              bullet_1:
                'U.GGデスクトップアプリのリリースを実装し、保守を担当させました。',
              bullet_1_5:
                'KPI: 150万回以上のダウンロード, 420万ドル以上の収益, 18万以上の毎日使っているユーザー',
              bullet_2:
                '300万毎日使っているユーザーのウェブサイトを重要アップデートと新しい設計を実装しました。 ',
              bullet_3:
                'Figmaで設計されたコンポーネントとアニメーションを再利用可能に実装した。',
              bullet_4:
                '広告パートナー企業（Overwolf、Playwire）のプラットフォーム技術、API、内部ツールを実装しました。',
              bullet_5:
                'パフォーマンスとスケーラビリティの問題を解決しました。',
            },
            oracle: {
              duration: '2019年夏 - 2021年春',
              location: '米国、カリフォルニア州、サンタモニカ',
              company: 'オラクル株式会社',
              title: 'クラウドエンジニア',
              bullet_1:
                '顧客の依頼から行動計画使った、オラクルクラウドで実装しました。',
              bullet_2:
                'APIプロトコルとデータ形式（REST、JSON、SOAP、XML）経験を積みました。',
              bullet_3:
                'シェルコマンドとSQLコマンド自動に実行するためにPythonスクリプトを作成しました。',
              bullet_4:
                '顧客の統合、データ変換の設計、構築、レビューを担当しました。',
            },
            gtri: {
              duration: '2018年春 - 2019年春',
              location: '米国、カリフォルニア州、サンディエゴ',
              company: 'GTRI',
              title: 'ITインターン',
              bullet_1: 'JIRAのアジャイルボードで依頼を上手く解決しました。',
              bullet_2:
                '社内Wiki（Confluence）に技術文書、マニュアル、ITポリシーを追加した。',
            },
            biosero: {
              duration: '2017年夏 - 2018年春',
              location: '米国、カリフォルニア州、サンディエゴ',
              company: 'バイオセロ株式会社',
              title: 'ソフトウェアエンジニアインターン',
              bullet_1:
                '新しいハードウェアに対応し、性能を向上させるためのドライバーソフトウェアを開発した。',
              bullet_2: '機能について自動テストと手動テストを選びました。',
              bullet_3:
                'ソフトウェアの問題を直したり、文書したり、報告しました。',
            },
          },
          education: {
            title: '学歴。',
            university: {
              name_1: 'カリフォルニア大学',
              name_2: 'サンディエゴ校',
              degree: '理学士、専攻：生命情報科学・副専攻：計算機科学',
              location: '米国、カリフォルニア州、ラホヤ',
              duration: '2015年秋 - 2019年夏'
            },
            study_abroad: {
              name: 'インターカルト日本語学校',
              degree: '留学・出席率: 99.6％',
              location: '日本東京都台東区',
              duration: '2025年春 - 2026年春'
            },
            languages: {
              title: '言語',
              english: {
                label: "英語：母国語"
              },
              japanese: {
                label: "日本語：ビジネス中級",
                exam_1: {
                  name: "日本語能力試験三級 (2026年冬)",
                  section_1: "言語知識【文字・語彙・文法】：43点／60点",
                  section_2: "読解：56点／60点",
                  section_3: "聴解：60点／60点",
                  section_total: "総合得点：158点／180点【合格】（CEFR：B1）",
                }
              },
              chinese: {
                label: "中国語：ビジネス初級",
                exam_1: {
                  name: "漢語水平考試3.0 (2026年春)",
                  section_1: "聴解：100点／100点",
                  section_2: "読解：100点／100点",
                  section_3: "筆記：88点／100点",
                  section_total: "総合得点：288点／300点【合格】",
                }
              },
            }
          },
          footer: {
            thanks: '最後まで読んでいただきありがとうございます！',
            heart_1: '',
            heart_2: 'を込めて作られました。',
            and: 'と',
          },
        },
      },
    },
  });

export default i18n;
